// extracted by css-extract-rspack-plugin
module.exports =  {"source-2":"Source2-NQkg__source-2","embed":"Source2-gqbG__embed"};